import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { A as AnchorLink } from "../../AnchorLink.js";
import { L as List } from "../../List.js";
import { useUuid } from "../../hooks/useUuid.js";
import { T as Title } from "../../Title.js";
import styles from "./styles.module.scss";
import { AnalyticsId } from "../../constants.js";
import { isComponent, isComponentWithDisplayName } from "../../utils/component.js";
import { C as Checkbox } from "../../Checkbox.js";
import { F as FormGroup } from "../../FormGroup.js";
import { I as Input } from "../../Input.js";
import { R as RadioButton } from "../../RadioButton.js";
import { S as Select } from "../../Select.js";
import { S as Slider } from "../../Slider.js";
import { T as Textarea } from "../../Textarea.js";
const ErrorListItem = (props) => {
  const handleClick = (event, element) => {
    event == null ? void 0 : event.preventDefault();
    (element == null ? void 0 : element.focus) && (element == null ? void 0 : element.focus());
  };
  if (props.error.ref) {
    return /* @__PURE__ */ jsx(AnchorLink, { href: `#${props.name}`, onClick: (e) => handleClick(e, props.error.ref), children: props.error.message });
  }
  return /* @__PURE__ */ jsx(Fragment, { children: props.error.message });
};
const ErrorList = (props) => /* @__PURE__ */ jsx(List, { children: Object.entries(props.errors).map(([name, error]) => /* @__PURE__ */ jsx(List.Item, { children: /* @__PURE__ */ jsx(ErrorListItem, { name, error }) }, name)) });
const ValidationSummary = (props) => {
  const { errorTitleHtmlMarkup = "h2" } = props;
  const titleId = useUuid();
  const hasErrors = !!props.errors && Object.entries(props.errors).length > 0;
  const summaryClasses = classNames(styles["validation__summary"], hasErrors && styles["validation__summary--visible"]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "status",
      "aria-atomic": "true",
      "aria-live": "polite",
      "aria-relevant": "all",
      "aria-labelledby": hasErrors && props.errorTitle ? titleId : void 0,
      className: summaryClasses,
      children: [
        hasErrors && /* @__PURE__ */ jsxs(Fragment, { children: [
          props.errorTitle && /* @__PURE__ */ jsx(Title, { appearance: "title4", id: titleId, htmlMarkup: errorTitleHtmlMarkup, margin: { marginTop: 0, marginBottom: 1 }, children: props.errorTitle }),
          /* @__PURE__ */ jsx(ErrorList, { errors: props.errors })
        ] }),
        props.children
      ]
    }
  );
};
const Validation = React__default.forwardRef((props, ref) => {
  const validationErrorClass = styles["validation__error-wrapper"];
  const cloneFormElement = (child) => {
    return React__default.cloneElement(child, {
      ...child.props,
      errorWrapperClassName: validationErrorClass
    });
  };
  const renderChild = (child) => {
    if (isComponent(child, FormGroup) || isComponent(child, Checkbox) || isComponent(child, RadioButton) || isComponent(child, Textarea) || isComponent(child, Input) || isComponent(child, Select) || isComponent(child, Slider) || isComponentWithDisplayName(child, "DateTimePickerWrapper") || isComponentWithDisplayName(child, "DatePicker") || isComponentWithDisplayName(child, "DateTime")) {
      return cloneFormElement(child);
    }
    if (React__default.isValidElement(child) && child.type === React__default.Fragment) {
      return React__default.Children.map(child.props.children, (child2) => {
        return renderChild(child2);
      });
    }
    return child;
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { "data-testid": props.testId, "data-analyticsid": AnalyticsId.Validation, className: props.className, ref, children: React__default.Children.map(props.children, (child) => renderChild(child)) }),
    /* @__PURE__ */ jsx(ValidationSummary, { errorTitle: props.errorTitle, errors: props.errors })
  ] });
});
Validation.displayName = "Validation";
export {
  Validation,
  Validation as default
};
//# sourceMappingURL=index.js.map
